module.exports = require('./stripWhitespace')
